import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { universalButtonService } from '@cobu/api-client';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../../store';
import { setUniversalButtonData } from '../../store/authSlice';
import { analyticsService, AnalyticsEvent } from '@cobu/analytics';

// Query keys
export const UNIVERSAL_BUTTON_KEYS = {
  getUniversalButtonData: (buildingUuid: string) => ['universalButton_getUniversalButtonData', buildingUuid],
};

/**
 * Hook for fetching universal button data
 */
export const useGetUniversalButtonDataQuery = (buildingUuid: string) => {
  const dispatch = useDispatch<AppDispatch>();

  const query = useQuery({
    queryKey: UNIVERSAL_BUTTON_KEYS.getUniversalButtonData(buildingUuid),
    queryFn: async () => {
      /* ANALYTICS_DISABLED: UNIVERSAL_BUTTON_FETCH_ATTEMPT ('universal_button_fetch_attempt')
        analyticsService.trackEvent(AnalyticsEvent.UNIVERSAL_BUTTON_FETCH_ATTEMPT, {
                buildingUuid,
              });
        */

      return universalButtonService.getUniversalButtonData(buildingUuid);
    },
    enabled: !!buildingUuid,
    staleTime: 0, // Always refetch
  });
  // Handle success and error with useEffect
  useEffect(() => {
    if (query.isSuccess && query.data) {
      dispatch(setUniversalButtonData(query.data));

      analyticsService.trackEvent(AnalyticsEvent.UNIVERSAL_BUTTON_FETCH_SUCCESS, {
        buildingUuid,
        buttonTitle: query.data.buttonTitle,
        linkType: query.data.linkType,
      });
    } else {
      dispatch(setUniversalButtonData(null));
    }
  }, [query.isSuccess, query.data, dispatch, buildingUuid]);

  // useEffect(() => {
  //   if (query.isError && query.error) {
  //     analyticsService.trackEvent(AnalyticsEvent.UNIVERSAL_BUTTON_FETCH_FAILURE, {
  //       buildingUuid,
  //       error: query.error.message,
  //     });
  //   }
  // }, [query.isError, query.error, buildingUuid]);

  return query;
};
